var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.service.title))]),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.service.description))]),_vm._l((_vm.service.services),function(service){return _c('side-bar-service',{key:service.name,attrs:{"service":service}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }